export default __webpack_public_path__ + "static/media/Mark-5-3D-Model-01.b46ede20.jpg";